import { render, staticRenderFns } from "./app-message.vue?vue&type=template&id=3c1a16dd&scoped=true&"
import script from "./app-message.vue?vue&type=script&lang=ts&"
export * from "./app-message.vue?vue&type=script&lang=ts&"
import style0 from "./app-message.vue?vue&type=style&index=0&id=3c1a16dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a16dd",
  null
  
)

export default component.exports